module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal animated fadeIn",
    class: {
      'is-active': _vm.isActive
    }
  }, [_c('div', {
    staticClass: "modal-background"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-card animated fadeInUp"
  }, [_c('header', {
    staticClass: "modal-card-head"
  }, [_c('span', {
    staticClass: "close-modal",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-close"
  })]), _vm._v(" "), _c('p', {
    staticClass: "modal-card-title"
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.send_proposal')))])]), _vm._v(" "), _c('section', {
    staticClass: "modal-card-body",
    staticStyle: {
      "overflow": "unset"
    }
  }, [_c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.from')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_vm._v("\n          " + _vm._s(_vm.spark.state.user.name) + " <" + _vm._s(_vm.spark.state.user.email) + ">\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.to')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select is-fullwidth"
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.contacts,
      "placeholder": _vm.$t('proposal_send_modal.to_placeholder'),
      "track-by": "id",
      "label": "name",
      "searchable": true,
      "showLabels": false,
      "multiple": true
    },
    model: {
      value: (_vm.payload.contacts),
      callback: function($$v) {
        _vm.$set(_vm.payload, "contacts", $$v)
      },
      expression: "payload.contacts"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }, [_c('label', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.subject_input.label')))])]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.subject),
      expression: "form.subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "input",
    attrs: {
      "name": "subject",
      "type": "text",
      "placeholder": _vm.$t('proposal_send_modal.subject_input.placeholder'),
      "disabled": _vm.sending
    },
    domProps: {
      "value": (_vm.form.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "subject", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "control is-horizontal"
  }, [_c('div', {
    staticClass: "control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('subject')),
      expression: "errors.has('subject')"
    }],
    staticClass: "help-block"
  }, [_vm._v(_vm._s(_vm.errors.first('subject')))])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "control message-area"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.body),
      expression: "form.body"
    }],
    attrs: {
      "name": "body",
      "placeholder": _vm.$t('proposal_send_modal.message_input.placeholder'),
      "disabled": _vm.sending
    },
    domProps: {
      "value": (_vm.form.body)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "body", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('footer', {
    staticClass: "modal-card-foot"
  }, [_c('a', {
    staticClass: "button is-primary is-large pull-left",
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.send
    }
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.send')) + " "), (_vm.sending) ? _c('loading-indicator', {
    attrs: {
      "color": "#ffffff"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('a', {
    staticClass: "button is-primary is-large is-outlined pull-left",
    attrs: {
      "disabled": _vm.sending
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(_vm._s(_vm.$t('proposal_send_modal.cancel')))])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-47b19d48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/modals/document-send-modal.vue
// module id = 524
// module chunks = 0